import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE, COURSE_OPTIONS } from "components/constant";
import React, { useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
} from "reactstrap";
import Select, { components } from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { Doughnut } from "react-chartjs-2";
import { colors } from "variables/charts";
import {
  COURSE_CATEGORY,
  COURSE_LEVELS,
  COURSE_TYPES,
  COURSE_MODE,
} from "components/constant";

function TraineeCourses() {
  const [pageNum, setPageNum] = useState(1);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [filterState, setFilterState] = useState({
    searchName: "",
    searchStatus: null,
    filterParams: [],
  });

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    {
      Header: "Course Name",
      accessor: "courseName",
    },
    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Level",
      accessor: "level",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Mode",
      accessor: "contentDeliveryMode",
    },
    {
      Header: "Enrolled On",
      accessor: "enrolledOn",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge color={value === "COMPLETED" ? "success" : "warning"} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isRowExpanded = expandedRowId === row.original.id;

        return (
          <button
            className="btn btn-link p-0 btn-sm"
            onClick={() => handleRowClick(row.original.id)}
          >
            {isRowExpanded ? "View Less" : "View More"}
          </button>
        );
      },
    },
  ];

  const sessionColumns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    {
      Header: "Session",
      accessor: "sessionName",
    },
    {
      Header: "Scheduled Date",
      accessor: "date",
    },
    {
      Header: "Start Time",
      accessor: "startTime",
    },
    {
      Header: "End Time",
      accessor: "endTime",
    },
    { Header: "Trainer", accessor: "trainerName" },
    {
      Header: "Attendance",
      accessor: "attendance",
      Cell: ({ value }) => (
        <Badge
          color={
            value === "PRESENT"
              ? "success"
              : value === "ABSENT"
                ? "warning"
                : "secondary"
          }
          pill
        >
          {value}
        </Badge>
      ),
    },
  ];

  const assessmentColumns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    {
      Header: "Assessment Name",
      accessor: "assessmentName",
    },
    {
      Header: "Attempt Count",
      accessor: "noOfAttempts",
    },
    {
      Header: "Score",
      accessor: "score",
    },
    {
      Header: "Result",
      accessor: "result",
      Cell: ({ value }) => (
        <Badge
          color={
            value === "PASS"
              ? "success"
              : value === "FAIL"
                ? "warning"
                : "secondary"
          }
          pill
        >
          {value}
        </Badge>
      ),
    },
    {
      Header: "Duration",
      accessor: "assessmentDuration",
    },
    {
      Header: "Assessment Date",
      accessor: "assessmentDate",
    },
  ];

  const coursesList = [
    {
      id: 1,
      courseName: "Electrical Safety",
      category: "Safety",
      level: "Beginner",
      type: "Recorded",
      contentDeliveryMode: "Online",
      enrolledOn: "15 Jan 2025, 05:13 PM",
      status: "COMPLETED",
    },
    {
      id: 2,
      courseName: "Power Systems Advanced",
      category: "Power Systems",
      level: "Advanced",
      type: "Live",
      contentDeliveryMode: "Online",
      enrolledOn: "18 Jan 2025, 05:13 PM",
      status: "IN_PROGRESS",
    },
    {
      id: 3,
      courseName: "Industrial Wiring Basics",
      category: "Electrical",
      level: "Beginner",
      type: "Recorded",
      contentDeliveryMode: "Offline + Online",
      enrolledOn: "20 Jan 2025, 05:13 PM",
      status: "COMPLETED",
    },
    {
      id: 4,
      courseName: "Substation Operations",
      category: "Power Systems",
      level: "Intermediate",
      type: "Live",
      contentDeliveryMode: "Offline",
      enrolledOn: "22 Jan 2025, 05:13 PM",
      status: "COMPLETED",
    },
    {
      id: 5,
      courseName: "Transformer Maintenance",
      category: "Electrical",
      level: "Advanced",
      type: "Recorded",
      contentDeliveryMode: "Online",
      enrolledOn: "24 Jan 2025, 05:13 PM",
      status: "IN_PROGRESS",
    },
    {
      id: 6,
      courseName: "Energy Management Basics",
      category: "Energy",
      level: "Beginner",
      type: "Recorded",
      contentDeliveryMode: "Online",
      enrolledOn: "26 Jan 2025, 05:13 PM",
      status: "COMPLETED",
    },
    {
      id: 7,
      courseName: "Panel Wiring Techniques",
      category: "Electrical",
      level: "Intermediate",
      type: "Live",
      contentDeliveryMode: "Offline + Online",
      enrolledOn: "27 Jan 2025, 05:13 PM",
      status: "IN_PROGRESS",
    },
    {
      id: 8,
      courseName: "Advanced Electrical Safety",
      category: "Safety",
      level: "Advanced",
      type: "Recorded",
      contentDeliveryMode: "Online",
      enrolledOn: "28 Jan 2025, 05:13 PM",
      status: "COMPLETED",
    },
    {
      id: 9,
      courseName: "Grid Operations Fundamentals",
      category: "Power Systems",
      level: "Beginner",
      type: "Live",
      contentDeliveryMode: "Offline",
      enrolledOn: "29 Jan 2025, 05:13 PM",
      status: "COMPLETED",
    },
  ];

  const courseScheduleList = [
    {
      id: 1,
      sessionName: "Introduction to Electrical Safety",
      date: "20 Jan 2025",
      startTime: "10:00 AM",
      endTime: "11:00 AM",
      attendance: "PRESENT",
      trainerName: "Sheetal Sharma",
    },
    {
      id: 2,
      sessionName: "Electrical Hazards & Risks",
      date: "22 Jan 2025",
      startTime: "10:00 AM",
      endTime: "11:30 AM",
      attendance: "PRESENT",
      trainerName: "Gokul Patil",
    },
    {
      id: 3,
      sessionName: "Safe Handling of Electrical Equipment",
      date: "24 Jan 2025",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      attendance: "ABSENT",
      trainerName: "Rahul Verma",
    },
    {
      id: 4,
      sessionName: "Emergency Procedures & First Aid",
      date: "26 Jan 2025",
      startTime: "10:00 AM",
      endTime: "11:00 AM",
      attendance: "Not Marked",
      trainerName: "Sheetal Sharma",
    },
  ];

  const assessmentList = [
    {
      id: 1,
      assessmentName: "Introduction to Electrical Safety",
      noOfAttempts: 2,
      score: "85%",
      result: "PASS",
      assessmentDate: "26 Jan 2025, 03:15 PM",
      assessmentDuration: "30 mins",
    },
    {
      id: 2,
      assessmentName: "Workplace Safety Basics",
      noOfAttempts: 1,
      score: "60%",
      result: "FAIL",
      assessmentDate: "20 Jan 2025, 12:45 PM",
      assessmentDuration: "25 mins",
    },
  ];

  const getDoughnutConfig = (key, labels, data, colorsArr) => ({
    data: {
      labels,
      datasets: [
        {
          data,
          backgroundColor: colorsArr,
          borderWidth: 0,
        },
      ],
    },
    options: {
      responsive: true,
      cutout: "80%",
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const label = context.label || "";
              const value = context.parsed;

              return ` ${value} ${key === "attendance" ? "days" : "%"} `;
            },
          },
        },
      },
      animation: {
        animateScale: false,
        animateRotate: false,
      },
    },
  });

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chart) {
      const { ctx, width, height } = chart;
      const centerText = chart.options.centerText;

      if (!centerText) return;

      ctx.save();

      ctx.font = "600 12px Open Sans";
      ctx.fillStyle = colors.gray[600];
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(centerText.label, width / 2, height / 2 - 10);

      ctx.font = "bold 18px Open Sans";
      ctx.fillStyle = centerText.color;
      ctx.fillText(centerText.value, width / 2, height / 2 + 10);

      ctx.restore();
    },
  };

  const attendancePresent = 85;
  const attendanceAbsent = 10;
  const attendanceNotMarked = 5;

  const attendanceChart = getDoughnutConfig(
    "attendance",
    ["Present", "Absent", "Not Marked"],
    [attendancePresent, attendanceAbsent, attendanceNotMarked],
    [colors.theme.success, colors.theme.warning, colors.gray[400]],
  );

  attendanceChart.options.centerText = {
    label: "Attendance",
    value: `${attendancePresent}%`,
    color: colors.theme.success,
  };

  const completionCompleted = 95;
  const completionInProgress = 5;
  const completionPending = 0;

  const completionChart = getDoughnutConfig(
    "status",
    [("Completed", "In Progress", "Pending")],
    [completionCompleted, completionInProgress, completionPending],
    [colors.theme.success, colors.gray[400], colors.theme.warning],
  );

  completionChart.options.centerText = {
    label: "Course Progress",
    value: `${completionCompleted}%`,
    color: colors.theme.success,
  };

  const renderCol = (label, value) => {
    return (
      <Col md="6" className="mb-3">
        <h4 className="text-muted mb-0">{label}</h4>
        <h4 className="mb-0">{value || "-"}</h4>
      </Col>
    );
  };

  const ExpandedCourseDetails = ({ course }) => {
    return (
      <div className="expanded-container">
        <Row>
          <Col md="6">
            <div className="course-summary">
              <div className="mb-3">
                <h4 className="text-muted mb-0">Course Name</h4>
                <h3 className="text-deep-blue mb-0">{course.courseName}</h3>
              </div>

              <Row>
                {renderCol("Type", course.type)}
                {renderCol("Level", course.level)}
                {renderCol("Mode", course.contentDeliveryMode)}
                {renderCol("Enrolled On", course.enrolledOn)}
              </Row>
            </div>
          </Col>
          <Col md="6">
            <div className="progress-charts">
              <div className="text-center">
                <Doughnut
                  data={completionChart.data}
                  options={completionChart.options}
                  plugins={[centerTextPlugin]}
                  className="chart-canvas"
                />
              </div>
              <div className="text-center">
                <Doughnut
                  data={attendanceChart.data}
                  options={attendanceChart.options}
                  plugins={[centerTextPlugin]}
                  className="chart-canvas"
                />
              </div>
            </div>
          </Col>
        </Row>

        <div className="divider"></div>

        <div className="mt-3">
          <h4 className="mb-1">Course Schedule & Attendance</h4>
          <h5 className="text-muted mb-3">
            Showing session-wise schedule and trainee attendance
          </h5>
          <CommonTable
            columns={sessionColumns}
            data={courseScheduleList || []}
            defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
            activePage={pageNum}
            setPageNum={setPageNum}
            totalPages={Math.ceil(
              courseScheduleList.length / DEFAULT_RECORDS_PER_PAGE,
            )}
            showPaginationBottom={true}
          />
        </div>

        <div className="divider"></div>

        <div className="mt-3">
          <h4 className="mb-1">Assessments</h4>
          <h5 className="text-muted mb-3">Showing assessment performance</h5>
          <CommonTable
            columns={assessmentColumns}
            data={assessmentList || []}
            defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
            activePage={pageNum}
            setPageNum={setPageNum}
            totalPages={Math.ceil(
              assessmentList.length / DEFAULT_RECORDS_PER_PAGE,
            )}
            showPaginationBottom={true}
          />
        </div>
      </div>
    );
  };

  const handleRowClick = (id) => {
    setExpandedRowId((prev) => (prev === id ? null : id));
  };

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={props.data.value === "COMPLETED" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={props.data.value === "COMPLETED" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  return (
    <Card className="mb-6">
      {/*<CardHeader>
         <h4 className="mb-0">Enrolled Courses</h4> 
      </CardHeader>*/}
      <CardBody className="p-4">
             <div className="mb-3"> (Static Data)</div>

        <div className="d-flex align-items-center justify-content-between mb-5 flex-wrap flex-column flex-md-row">
          <div className="d-flex flex-wrap align-items-center filter-group">
            <Input
              placeholder="Search by course name"
              className="mr-2 mb-2 filter-select"
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={COURSE_CATEGORY}
              placeholder="Category"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={COURSE_LEVELS}
              placeholder="Level"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={COURSE_TYPES}
              placeholder="Type"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={COURSE_MODE}
              placeholder="Mode"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={COURSE_OPTIONS}
              placeholder="Select Status"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
              components={{ Option, SingleValue }}
              value={filterState.searchStatus}
              onChange={(selected) =>
                setFilterState((prev) => ({
                  ...prev,
                  searchStatus: selected,
                }))
              }
            />

            <div className="d-flex mr-2 mb-2 align-items-center date-range-wrapper">
              <span className="mr-2">Enrolled On</span>
              <Input type="date" className="mr-1 mb-1 filter-select" />
              {/* <span className="mx-1">To</span>
              <Input type="date" className="ml-1 mb-1 filter-select" /> */}
            </div>

            <Button
              color="default"
              className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
            >
              <i className="fa fa-search mr-1" />
              Search
            </Button>
          </div>
        </div>
        <div className="mt-2 mb-3 mx-1">
          <span className="total-records">
            Total Records : {coursesList.length}
          </span>
        </div>
        <CommonTable
          columns={columns}
          data={coursesList || []}
          defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
          activePage={pageNum}
          setPageNum={setPageNum}
          totalPages={Math.ceil(coursesList.length / DEFAULT_RECORDS_PER_PAGE)}
          showPaginationBottom={true}
          // rowClick={(row) => handleOnRowClick(row)}
          expandedRowIndex={expandedRowId}
          renderExpandedRow={(row) =>
            expandedRowId === row.id ? (
              <ExpandedCourseDetails course={row} />
            ) : null
          }
        />
      </CardBody>
    </Card>
  );
}

export default TraineeCourses;
